import React from 'react'
import { makeStyles } from '@material-ui/core'

import Button from '../button/Button'
import UserAvatar from '../shared/UserAvatar'
import { relationOptions } from '../../utils/constants'
import InputSelect from '../select/InputSelect'
import CustomTable from '../table/CustomTable'
import characterMagnifyingGlass from '../../assets/icons/ilustration-character-with-magnifying-glass.svg'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 40,
    fontFamily: 'Montserrat, Source Sans Pro',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    height: '100%',
    width: '96%'
  },
  authorize_pickup_btn: {
    backgroundColor: '#92CB5A',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#92CB5A'
    },
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'capitalize',
    lineHeight: '100%',
    height: 48,
    width: 300
  },
  inputs_wrapper: {
    display: 'flex',
    columnGap: 32,
    alignItems: 'flex-start'
  },
  input_wrapper: {
    width: 325
  },
  avatar_wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    '& p': {
      fontWeight: 500,
      fontSize: 16,
      color: '#555555'
    }
  },
  table_root: {
    marginTop: 32
  },
  without_authorization_fallback: {
    marginTop: 52,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& .fallback_description': {
      '& h1': {
        fontWeight: 600,
        fontSize: 20,
        margin: 0,
        marginBottom: 8
      },
      '& p': {
        color: '#7B7B7B',
        fontWeight: 500,
        fontSize: 12,
        margin: 0
      }
    }
  },
  img_wrapper: {
    width: 240,
    height: 270
  }
}))

const PickupByChildView = props => {
  const {
    getChildrenRSPA,
    setParentComponentChild,
    setPickupConfirmationModal,
    getPickupAuthorizations,
    authorizations
  } = props
  const classes = useStyles()
  const authorizationType = {
    permanent: 'Autorização fixa',
    temporary: 'Somente hoje'
  }
  const [selectedChild, setSelectedChild] = React.useState([])
  const [searchParams, setSearchParams] = React.useState({})
  const columns = [
    {
      key: 'name',
      name: 'Reponsável',
      width: '25%',
      render: row => {
        const parentData = {
          ...(row?.user_id
            ? { name: row?.user?.name, photo: row?.user?.avatar_url }
            : { name: row?.name, photo: row?.photo_url })
        }
        return (
          <div className={classes.avatar_wrapper}>
            <UserAvatar
              avatarStyle={{
                width: 40,
                height: 40
              }}
              withoutUserName
              userName={parentData.name}
              avatarUrl={parentData.photo}
            />
            <p>{parentData.name}</p>
          </div>
        )
      }
    },
    {
      key: 'relationship_type',
      name: 'Vínculo',
      width: '12%',
      render: row => {
        return (
          <p>
            {relationOptions.find(
              item => item?.value === row?.relationship_type
            )?.label || '--'}
          </p>
        )
      }
    },
    {
      key: 'taxpayer_number',
      name: 'CPF',
      width: '12%',
      render: row => {
        return <p>{row?.taxpayer_number}</p>
      }
    },
    {
      key: 'phone',
      name: 'Telefone',
      width: '12%',
      render: row => {
        return <p>{row?.phone || '--'}</p>
      }
    },
    {
      key: 'vehicle_plate',
      name: 'Placa',
      width: '10%',
      render: row => {
        return <p>{row?.vehicle_plate?.toUpperCase() || '--'}</p>
      }
    },
    {
      key: 'authorize_action',
      name: '',
      width: '16%',
      render: row => {
        const resposible_type_by_user = row?.user?.child_parents?.find(
          cp => +cp.child_id === +selectedChild?.[0]?.id
        )?.relationship_type
        const responsible_name = row?.user_id ? row.user?.name : row.name
        const responsible_photo = row?.user_id
          ? row.user?.avatar_url
          : row.photo_url

        const responsible_type = row?.user_id
          ? relationOptions.find(
              relationship => relationship.value === resposible_type_by_user
            )?.label
          : relationOptions.find(
              relationship => relationship.value === row?.relationship_type
            )?.label
        return (
          <Button
            type='button'
            onclick={() =>
              setPickupConfirmationModal({
                id: row.id,
                open: true,
                data: {
                  responsible_name,
                  responsible_photo,
                  responsible_type,
                  authorization_data: {
                    type: authorizationType[row.pickup_type],
                    vehicle_plate: row?.vehicle_plate?.toUpperCase()
                  }
                }
              })
            }
            className={classes.authorize_pickup_btn}
          >
            Autorizar saída
          </Button>
        )
      }
    }
  ]
  const handleChangeChild = value => {
    setSelectedChild(value)
    setParentComponentChild(value)
  }
  React.useEffect(
    () => {
      if (selectedChild.length > 0) {
        const params = {
          'q[children_id_eq]': selectedChild?.[0]?.id,
          'q[pickup_type_eq]': 1,
          include:
            'user.child_parents,authorized_by,pickup_authorization_children.child.classrooms,school'
        }
        setSearchParams(params)
        getPickupAuthorizations({
          params
        })
      }
    },
    [selectedChild]
  )

  return (
    <div className={classes.root}>
      <div className={classes.inputs_wrapper}>
        <InputSelect
          wrapperClass={classes.input_wrapper}
          fetchItems={getChildrenRSPA}
          selectedItems={selectedChild}
          setSelectedItems={handleChangeChild}
          attributesFromItem={['avatar_url', 'name']}
          placeholder={'Digite o nome do aluno'}
          label={'Buscar aluno'}
          params={{
            'page[size]': 7,
            'q[classroom_child_classroom_year_lteq]':
              new Date().getFullYear() + 1,
            'q[classroom_child_classroom_year_gteq]': new Date().getFullYear()
          }}
        />
      </div>
      {selectedChild?.[0] ? (
        <CustomTable
          classRoot={classes.table_root}
          columns={columns}
          from={'authorizations'}
          noDataAlert={
            'Ninguém além dos responsáveis legais e com acesso ao aplicativo está autorizado a retirar a criança.'
          }
          data={authorizations.items}
          fetchItems={getPickupAuthorizations}
          params={{
            ...searchParams,
            include:
              'user.child_parents,authorized_by,pickup_authorization_children.child.classrooms,school'
          }}
          isFetching={authorizations.isFetching}
          pagination={authorizations.pagination}
          columnsPointer={[0]}
          border={'none'}
          headCellRadius
          headColor={'rgba(173, 184, 204, 0.3)'}
        />
      ) : (
        <div className={classes.without_authorization_fallback}>
          <img className={classes.img_wrapper} src={characterMagnifyingGlass} />
          <div className='fallback_description'>
            <h1>Configure os filtros para começar</h1>
            <p>Selecione o aluno ou o responsável para iniciar a busca</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default PickupByChildView
